import { render } from "./LangButton.vue?vue&type=template&id=a3428c0a"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__